/* =================================================================
   E3 MEGA MENU — behaviour
   Markup: snippets/e3-mega-menu.liquid   Styles: assets/e3-mega-menu.css

   Scope of this file:
     - desktop: make switching in the left rail (hover intent + click + focus)
     - both:    the shared filter engine (chassis code / model / year), which
                drives per-make hit counts on BOTH surfaces at once
     - drawer:  one-at-a-time <details> accordions
     - both:    position-aware edge fades (scrollbars are hidden in CSS)

   NOT in scope: opening/closing the desktop panel. That is Ella's own
   `mega-menu-details` custom element (assets/details-disclosure.js) — the
   panel is mounted inside the theme's <details class="mega-menu"> so it gets
   hover-intent, click-outside, Esc and focus-out for free, and it still
   opens natively as a <details> when JS is off.
   ================================================================= */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-e3-mm]');
  if (!roots.length) return;

  var SWAP_DELAY = 80;

  /* ---------- 1. desktop make switching ---------- */
  Array.prototype.forEach.call(roots, function (root) {
    if (root.getAttribute('data-e3-mm') !== 'desktop') return;

    var rail = root.querySelector('.e3-mm__rail-sc');
    var panes = root.querySelector('.e3-mm__panes-sc');
    if (!rail || !panes) return;

    var swapTimer;

    function activate(name) {
      Array.prototype.forEach.call(rail.querySelectorAll('.e3-mm__mk'), function (b) {
        var on = b.getAttribute('data-make') === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panes.querySelectorAll('.e3-mm__pane'), function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-make') === name);
      });
      panes.scrollTop = 0;
      refreshFades();
    }

    rail.addEventListener('mouseover', function (e) {
      var b = e.target.closest('.e3-mm__mk');
      if (!b) return;
      clearTimeout(swapTimer);
      swapTimer = setTimeout(function () {
        activate(b.getAttribute('data-make'));
      }, SWAP_DELAY);
    });
    rail.addEventListener('mouseleave', function () {
      clearTimeout(swapTimer);
    });
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('.e3-mm__mk');
      if (!b) return;
      clearTimeout(swapTimer);
      activate(b.getAttribute('data-make'));
    });
    rail.addEventListener('focusin', function (e) {
      var b = e.target.closest('.e3-mm__mk');
      if (b) activate(b.getAttribute('data-make'));
    });
  });

  /* ---------- 2. shared filter engine ---------- */
  var rows = Array.prototype.slice.call(document.querySelectorAll('.e3-mm [data-hay]'));
  var inputs = Array.prototype.slice.call(document.querySelectorAll('.js-e3-mm-filter'));
  var groups = Array.prototype.slice.call(document.querySelectorAll('.e3-mm__grp'));

  function matches(row, tokens) {
    var hay = row.getAttribute('data-hay');
    var y0 = parseInt(row.getAttribute('data-y0'), 10);
    var y1 = parseInt(row.getAttribute('data-y1'), 10);
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      var ok = hay.indexOf(t) !== -1;
      if (!ok && /^\d{4}$/.test(t)) {
        var n = parseInt(t, 10);
        ok = !!y0 && n >= y0 && n <= y1;
      }
      if (!ok) return false;
    }
    return true;
  }

  function visibleIn(el) {
    return el.querySelectorAll('[data-hay]:not(.is-e3-hid)').length;
  }

  function apply(q) {
    var tokens = q.toLowerCase().replace(/[\/,-]/g, ' ').split(/\s+/).filter(Boolean);
    var active = tokens.length > 0;

    rows.forEach(function (r) {
      r.classList.toggle('is-e3-hid', active && !matches(r, tokens));
    });
    groups.forEach(function (g) {
      g.classList.toggle('is-e3-hid', !g.querySelector('[data-hay]:not(.is-e3-hid)'));
    });

    /* one number for the hint line: how many of the 69 chassis rows survive.
       Each row exists on both surfaces, so count the desktop copies only. */
    var totalHits = rows.filter(function (r) {
      return !r.classList.contains('is-e3-hid') && !r.classList.contains('e3-mm__rw--m');
    }).length;

    Array.prototype.forEach.call(roots, function (root) {
      var rootHits = visibleIn(root);

      /* desktop: panes with a hit are stacked while filtering */
      Array.prototype.forEach.call(root.querySelectorAll('.e3-mm__pane'), function (p) {
        p.classList.toggle('has-hit', visibleIn(p) > 0);
      });

      /* desktop rail: hide makes with no hit, swap the count to the hit count */
      Array.prototype.forEach.call(root.querySelectorAll('.e3-mm__mk'), function (b) {
        var pane = root.querySelector(
          '.e3-mm__pane[data-make="' + cssEscape(b.getAttribute('data-make')) + '"]'
        );
        var n = pane ? visibleIn(pane) : 0;
        b.classList.toggle('is-e3-hid', active && n === 0);
        setCount(b, active ? n : b.getAttribute('data-total'));
      });

      /* drawer: auto-open makes that have hits while filtering */
      Array.prototype.forEach.call(root.querySelectorAll('.e3-mm__acc'), function (acc) {
        var n = visibleIn(acc);
        acc.classList.toggle('is-e3-hid', active && n === 0);
        acc.open = active ? n > 0 : false;
        setCount(acc, active ? n : acc.getAttribute('data-total'));
      });

      root.classList.toggle('is-filtering', active);
      root.classList.toggle('is-empty', active && rootHits === 0);
    });

    var word = totalHits === 1 ? 'vehicle matches' : 'vehicles match';
    Array.prototype.forEach.call(document.querySelectorAll('.js-e3-mm-count'), function (el) {
      el.hidden = !active;
      if (active) {
        el.innerHTML =
          '<b>' + totalHits + '</b> ' + word + ' &ldquo;' + escapeHtml(q) + '&rdquo;';
      } else {
        el.textContent = '';
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.js-e3-mm-q'), function (el) {
      el.textContent = q;
    });

    refreshFades();
  }

  function setCount(scope, value) {
    var el = scope.querySelector('.e3-mm__mk-n');
    if (el) el.textContent = value;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function cssEscape(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
  }

  inputs.forEach(function (inp) {
    inp.addEventListener('input', function () {
      inputs.forEach(function (o) {
        if (o !== inp) o.value = inp.value;
      });
      apply(inp.value.trim());
    });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && inp.value) {
        e.stopPropagation(); /* don't let Ella close the whole panel on the first Esc */
        clearAll();
      }
    });
  });

  function clearAll() {
    inputs.forEach(function (o) {
      o.value = '';
    });
    apply('');
  }

  Array.prototype.forEach.call(document.querySelectorAll('.js-e3-mm-clear'), function (x) {
    x.addEventListener('click', function () {
      clearAll();
      if (inputs[0]) inputs[0].focus();
    });
  });

  /* ---------- 3. drawer: one accordion at a time ---------- */
  Array.prototype.forEach.call(roots, function (root) {
    if (root.getAttribute('data-e3-mm') !== 'drawer') return;

    /* Ella's <header-drawer> (global.js, class MenuDrawer ~1458) binds
       onSummaryClick to EVERY <summary> inside itself and adopts the FIRST
       <details> it finds as its own drawer toggle. Our accordion supplies all
       17 of both, so AUDI became the "drawer toggle" and every other make took
       the submenu branch — which sets `submenu-open` on the enclosing
       .menu-drawer__menu.has-submenu, and component-menu-drawer.css:43 hides
       that outright. Tapping any make but AUDI blanked the whole drawer.

       Their listeners sit on the summaries themselves, so a capture-phase
       stopPropagation here keeps the click from ever reaching them. Capture
       always precedes the target phase, so this does not depend on script
       order. The native <details> toggle is a default action, not a listener,
       so it still fires — and so does our own `toggle` handler below. */
    root.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.e3-mm__acc-head')) e.stopPropagation();
      },
      true
    );

    var accs = Array.prototype.slice.call(root.querySelectorAll('.e3-mm__acc'));
    accs.forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        if (root.classList.contains('is-filtering')) return; /* filtering opens many on purpose */
        accs.forEach(function (o) {
          if (o !== acc) o.open = false;
        });
      });
    });
  });

  /* ---------- 4. position-aware edge fades ---------- */
  var fades = Array.prototype.slice.call(document.querySelectorAll('.e3-mm-fade'));

  function refreshFades() {
    fades.forEach(function (f) {
      var sc = f.querySelector('.js-e3-mm-sc') || f;
      var over = sc.scrollHeight - sc.clientHeight;
      f.classList.toggle('is-f-top', sc.scrollTop > 4);
      f.classList.toggle('is-f-bot', over > 4 && sc.scrollTop < over - 4);
    });
  }

  fades.forEach(function (f) {
    var sc = f.querySelector('.js-e3-mm-sc') || f;
    sc.addEventListener('scroll', refreshFades, { passive: true });
  });
  window.addEventListener('resize', refreshFades);
  window.addEventListener('load', refreshFades);

  /* the desktop panel is hidden until Ella opens it, so clientHeight reads 0
     at parse time — recompute whenever the panel's open state changes */
  Array.prototype.forEach.call(document.querySelectorAll('details.e3-mm-details'), function (d) {
    var obs = new MutationObserver(function () {
      setTimeout(refreshFades, 350); /* after Ella's 0.3s Motion transition */
    });
    obs.observe(d, { attributes: true, attributeFilter: ['open'] });
  });

  refreshFades();
})();
